import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { convertCentsToDecimalString } from '@grandvisionhq/utils';

const useTransactionInfo = ()=>{
    const { getLabel  } = useIntl();
    const mapLineItems = React.useCallback(({ cartPrices , lineItems , country , currency  })=>{
        const displayItems = (lineItems !== null && lineItems !== void 0 ? lineItems : []).map((lineItem)=>({
                label: lineItem.name,
                type: 'LINE_ITEM',
                price: lineItem.price
            })
        );
        if (cartPrices) {
            displayItems.push({
                label: getLabel('common.subtotal'),
                type: 'SUBTOTAL',
                price: convertCentsToDecimalString(cartPrices.subTotalPrice)
            });
            displayItems.push({
                label: getLabel('common.shipping'),
                type: 'SHIPPING_OPTION',
                price: convertCentsToDecimalString(cartPrices.shippingPrice)
            });
            if (cartPrices.discountPrice > 0) {
                displayItems.push({
                    label: getLabel('common.additionalDiscount'),
                    type: 'DISCOUNT',
                    price: convertCentsToDecimalString(cartPrices.discountPrice)
                });
            }
        }
        return {
            displayItems,
            countryCode: country,
            currencyCode: currency,
            totalPriceStatus: 'FINAL',
            totalPrice: convertCentsToDecimalString(cartPrices === null || cartPrices === void 0 ? void 0 : cartPrices.totalPrice),
            totalPriceLabel: getLabel('common.total')
        };
    }, [
        getLabel
    ]);
    return React.useMemo(()=>[
            mapLineItems
        ]
    , [
        mapLineItems
    ]);
};

export { useTransactionInfo };
//# sourceMappingURL=use-transaction-info.js.map
